<script lang="tsx">
  import { BasicArrow } from '@mts/components/Basic';

  const ExpandIcon = (props: Recordable) => {
    const { expandable, needIndentSpaced, record, expanded, onExpand } = props;

    if (!expandable) {
      return needIndentSpaced ? (
        <span class="ant-table-row-expand-icon ant-table-row-spaced" />
      ) : (
        <span />
      );
    }
    return (
      <BasicArrow
        class="mr-8px float-left"
        style="margin-top: -2px;"
        onClick={(e: Event) => {
          e.stopPropagation();
          onExpand(record, e);
        }}
        expand={expanded}
      />
    );
  };

  export default ExpandIcon;
</script>
